import { t } from "@lingui/core/macro";
import { Tabs } from "@mantine/core";
import { Route, Routes, useLocation, useNavigate } from "react-router";
import { ClientDetails } from "./components/ClientDetails/ClientDetails";
import { ClientsTable } from "./components/ClientsTable";
import { EracuniIndex } from "./Eracuni";
import PricingTiers from "./PricingTiers";
import React from "react";
import PricingTierEdit from "./PricingTiers/PricingTierEdit";
import { EmailActivity } from "./EmailActivity/EmailActivity";
import { LimePageHeader } from "@/Components/LimePageHeader";
import InvoicesPage from "./InvoicesPage";
import InvoiceDetailsById from "./InvoiceDetailsById";

export const LimeAdmin = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = React.useState(() => {
    const path = location.pathname.split("/").pop();
    if (["email-activity", "pricing-tiers"].includes(path ?? "")) {
      return path;
    }

    return "clients";
  });

  const handleTabChange = (value: string | null) => {
    if (value) {
      if (value === "clients") {
        setTabValue("clients");
        navigate("/dashboard/admin");
        return;
      }

      setTabValue(value);
      navigate(`/dashboard/admin/${value}`);
    }
  };

  return (
    <>
      <LimePageHeader title={t`Admin`} px={14} />
      <Tabs
        defaultValue="clients"
        value={tabValue}
        onChange={handleTabChange}
        keepMounted={false}
        orientation="horizontal"
      >
        <Tabs.List>
          <Tabs.Tab value="clients">{t`Clienti`}</Tabs.Tab>
          <Tabs.Tab value="pricing-tiers">{t`Cenilni razredi`}</Tabs.Tab>
          <Tabs.Tab value="invoices">{t`Računi`}</Tabs.Tab>
          <Tabs.Tab value="email-activity">{t`Email aktivnost`}</Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <Routes>
        <Route path="/" element={<ClientsTable />}></Route>
        <Route
          path="client/:id/*"
          element={<ClientDetails></ClientDetails>}
        ></Route>

        <Route path="eracuni/*" element={<EracuniIndex></EracuniIndex>}></Route>
        <Route
          path="pricing-tiers"
          element={<PricingTiers></PricingTiers>}
        ></Route>
        <Route
          path="pricing-tiers/:pricingTierId"
          element={<PricingTierEdit></PricingTierEdit>}
        ></Route>
        <Route path="invoices" element={<InvoicesPage></InvoicesPage>}></Route>
        <Route
          path="invoices/:clientId/:invoiceId"
          element={<InvoiceDetailsById></InvoiceDetailsById>}
        ></Route>
        <Route
          path="email-activity"
          element={<EmailActivity></EmailActivity>}
        ></Route>
      </Routes>
    </>
  );
};
